import React from "react";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { useAppSelector } from "@src/store/hooks";
import { FileText, FileX, X } from "lucide-react";
import styles from "./BulkExternalNotes.module.scss";
import helperStyles from "@src/components/helpers.module.scss";
import { clx } from "../utils/stringUtils";
import { formatCurrency } from "../utils/numberUtils";
import { getSplitsName } from "../utils/marketplaceUtils";
import { parseExternalNotes } from "./traits";

type TBulkExternalNotesItem = {
	data: EventInventoryRecord;
	onRemove?: (x: number) => void;
};

const BulkExternalNotesItem = ({ data, onRemove }: TBulkExternalNotesItem) => {
	const selectionEvent = useAppSelector((state) => state.pricing.selection.event);

	const itemAny = data as EventInventoryRecord & { Event_Headliner?: string; Event_Name?: string };
	const eventName = itemAny.Event_Headliner ?? itemAny.Event_Name ?? selectionEvent?.Event_Headliner ?? "";

	const splitName = getSplitsName(data.StubHub_Splits);
	const { traits: parsedTraits, leftovers } = parseExternalNotes(data.External_Notes);
	const notes = [...parsedTraits, ...leftovers];

	return (
		<div className={styles.singleListing}>
			<div className={styles.secRowSeat}>
				<div className={styles.secRowSeatCont}>
					<div style={{ userSelect: "none" }} className={clx(styles.itemTextPrimary, helperStyles.ellipsisDiv)}>
						{eventName}
					</div>
					<div className={styles.itemTextPrimary}>
						{data.Section}, Row {data.Row}
					</div>
					<div style={{ gap: "2px 8px" }} className={clx(styles.textSecondary, helperStyles.flexSmallGap)}>
						<div>ID: {data.Listing_ID}</div>
						<div>Seat {data.Seats}</div>
					</div>
					<div className={styles.notePills}>
						{notes.length ? (
							<>
								<span className={styles.hasNotes}>
									<FileText size={12} />
									Has notes
								</span>
								{notes.map((n) => (
									<span key={n} className={styles.notePill}>
										{n}
									</span>
								))}
							</>
						) : (
							<span className={clx(styles.hasNotes, styles.noNotes)}>
								<FileX size={12} />
								No notes
							</span>
						)}
					</div>
				</div>
			</div>
			<div className={clx(styles.qty, helperStyles.ellipsisDiv)}>{data.Quantity}</div>
			<div className={clx(styles.splitLabel, helperStyles.ellipsisDiv)}>{splitName}</div>
			<div className={clx(styles.priceLabel, helperStyles.ellipsisDiv)}>{formatCurrency(data.Item_Price)}</div>
			<div onClick={() => onRemove?.(data.Listing_ID)} className={styles.xContainer}>
				<div>
					<X size={16} />
				</div>
			</div>
		</div>
	);
};

export default BulkExternalNotesItem;
